<div class="select-all">

<mat-checkbox disableRipple (click)="$event.stopPropagation()" (change)="$event ? selectAllToggle() : null"
  [checked]="isAllSelected()">{{'form.controls.selectAllCheckBox' | translate}}
</mat-checkbox>

</div>
